import type {
  ContentApiImage,
  SmartSearchImageUrl,
} from '@libs/trip-planner-interfaces';

export const enum GalleryType {
  Masonry = 'masonry',
  Swiper = 'swiper',
}

export const enum HotelDetailsGalleryType {
  MasonryForHotel = 'masonryForHotel',
  SingleImageForHotel = 'singleImageForHotel',
  SingleImageForRoom = 'singleImageForRoom',
}

export interface HotelDetailsGalleryData {
  images: ContentApiImage[] | SmartSearchImageUrl[];
  header?: string;
}

export interface HotelDetailsFullscreenMasonryGalleryData {
  index: number;
  images: ContentApiImage[] | SmartSearchImageUrl[];
}
